module.exports = __webpack_public_path__ + "img/warning.90df0105.svg";